const globPattern = /(^|\/[^:.]*)(\*|\(\.\*\)$)/;

export default function replaceGlobal(url: string): string {
  return url.replace(globPattern, (...args) => {
    const [, path, modifier] = args;

    const globalPlaceholder = path.endsWith('/')
      ? `:glob${modifier}`
      : `/:glob${modifier}`;

    return `${path}${modifier ? globalPlaceholder : ''}`;
  });
}
